import { render, staticRenderFns } from "./Weighing.vue?vue&type=template&id=18a23db2"
import script from "./Weighing.vue?vue&type=script&lang=js"
export * from "./Weighing.vue?vue&type=script&lang=js"
import style0 from "./Weighing.vue?vue&type=style&index=0&id=18a23db2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports